import { type Key, memo, useState } from 'react';
import { useService } from './DistributionLists.hooks.ts';
import type { DistributionListFormValues } from './DistributionLists.types.ts';

import DistributionLists from './DistributionLists';
import { getDistributionListData } from './DistributionList.helpers.ts';

export const DistributionListsContainer = () => {
  const [selectedDistributionListKeys, setSelectedDistributionListKeys] = useState<React.Key[]>([]);
  const [openDistributionListDrawer, setOpenDistributionListDrawer] = useState<boolean>(false);
  const [distributionListId, setDistributionListId] = useState<number | null>(null);
  const { createMutation, updateMutation, deleteMutation, lists, isLoading } = useService({
    distributionListId,
  });

  const handleOpenDistributionListDrawer = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    id: number | null,
  ) => {
    if (event) event.preventDefault();
    if (id === undefined) return;

    setDistributionListId(id);
    setOpenDistributionListDrawer(true);
  };

  const handleCloseDistributionListDrawer = () => {
    setDistributionListId(null);
    setOpenDistributionListDrawer(false);
  };

  const handleSubmitDistributionList = (values: DistributionListFormValues) => {
    const data = getDistributionListData(values);
    if (values?.id) {
      updateMutation.mutate({ data: { ...data, id: values.id } });
      handleCloseDistributionListDrawer();
      return;
    }
    createMutation.mutate(data);
    handleCloseDistributionListDrawer();
  };

  const handleDeleteDistributionLists = () => {
    setDistributionListId(null);
    setSelectedDistributionListKeys([]);
    const params = { ids: selectedDistributionListKeys.map((key: Key) => Number(key)) };
    deleteMutation.mutate(params);
  };

  return (
    <DistributionLists
      distributionLists={lists}
      isLoading={isLoading}
      openDistributionListDrawer={openDistributionListDrawer}
      onOpenDistributionListDrawer={handleOpenDistributionListDrawer}
      onCloseDistributionListDrawer={handleCloseDistributionListDrawer}
      onSubmitDistributionList={handleSubmitDistributionList}
      selectedDistributionListKeys={selectedDistributionListKeys}
      setSelectedDistributionListKeys={setSelectedDistributionListKeys}
      onDeleteDistributionLists={handleDeleteDistributionLists}
      distributionListId={distributionListId}
      itemsToDeleteCount={selectedDistributionListKeys.length}
    />
  );
};

export default memo(DistributionListsContainer);
